/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon16Solid = forwardRef('NatureFxLightningAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.212 1a1 1 0 0 0-.987.836l-1.166 7A1 1 0 0 0 4.045 10h1.66l-.789 4.78c-.167 1.017 1.127 1.592 1.769.786l6.328-7.943A1 1 0 0 0 12.231 6H9.643l.998-3.742A1 1 0 0 0 9.675 1H5.212Z" })));
});
